import type { Case } from "./useRealtimeCases";

export const PAX_RANGES = [
  { value: "1-20", label: "1 à 20 pax", min: 1, max: 20 },
  { value: "21-50", label: "21 à 50 pax", min: 21, max: 50 },
  { value: "51-100", label: "51 à 100 pax", min: 51, max: 100 },
  { value: "101-200", label: "101 à 200 pax", min: 101, max: 200 },
  { value: "201+", label: "201 pax et plus", min: 201, max: Infinity },
];
export function caseBudget(c: Case): number | null {
  if (c.budget != null && Number.isFinite(c.budget) && c.budget >= 0) return c.budget;
  const pax = c.participants ?? c.pax;
  return c.budget_per_person != null && c.budget_per_person >= 0 && pax != null && pax > 0
    && Number.isFinite(c.budget_per_person * pax) ? c.budget_per_person * pax : null;
}
export function matchesDemandFilters(c: Case, paxFilter: string, budgetFilter: string) {
  const pax = c.participants ?? c.pax;
  const range = PAX_RANGES.find(r => r.value === paxFilter);
  const paxMatches = paxFilter === "all" || (paxFilter === "unknown" ? pax == null || pax <= 0
    : !!range && pax != null && pax >= range.min && pax <= range.max);
  const budget = caseBudget(c);
  const min = Number(budgetFilter);
  const budgetMatches = budgetFilter === "all" || (budgetFilter === "unknown" ? budget === null
    : budgetFilter === "over-15000" ? budget !== null && budget > 15000
    : budget !== null && Number.isFinite(min) && budget >= min && (min === 13500 ? budget <= 15000 : budget < min + 1500));
  return paxMatches && budgetMatches;
}
